import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { FaLock, FaShieldAlt, FaUserShield, FaDatabase, FaCog, FaEnvelope, FaUserCog, FaTrashAlt, FaMapMarkerAlt } from 'react-icons/fa';
import { BsShieldCheck, BsInfoCircle } from 'react-icons/bs';
import { RiContactsBookLine } from 'react-icons/ri';
import Layout from '../components/layout/Layout';
import './LegalPages.css';

const PrivacyPolicy = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Layout>
      <Container className="legal-page">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="text-center mb-5">
            <FaLock size={48} className="text-primary mb-3" />
            <h1 className="page-title">Privacy Policy</h1>
            <p className="last-updated">
              <BsInfoCircle className="me-2" />
              Last Updated: July 20, 2025
            </p>
          </div>
          
          <section className="mb-5">
            <p>
              Welcome to UniTrade! This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you use our platform. Please read this policy carefully. If you do not agree with the terms of this 
              privacy policy, please do not access the site.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaDatabase className="me-2" />
              1. Information We Collect
            </h2>
            <p>We collect several types of information from and about users of our website, including:</p>
            
            <h5>Personal Information</h5>
            <ul>
              <li>Name and contact information (email, phone number, address)</li>
              <li>University affiliation and student status</li>
              <li>Payment and transaction information</li>
              <li>Profile information and preferences</li>
            </ul>
            
            <h5>Usage Data</h5>
            <p>We may automatically collect information about how you access and use the service, including:</p>
            <ul>
              <li>IP address and device information</li>
              <li>Browser type and version</li>
              <li>Pages visited and time spent on pages</li>
              <li>Search terms and interaction data</li>
            </ul>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaCog className="me-2" />
              2. How We Use Your Information
            </h2>
            <p>We may use the information we collect for various purposes, including to:</p>
            
            <ListGroup variant="flush" className="mb-4">
              <ListGroup.Item>• Provide, maintain, and improve our services</ListGroup.Item>
              <ListGroup.Item>• Process transactions and send related information</ListGroup.Item>
              <ListGroup.Item>• Send you technical notices and support messages</ListGroup.Item>
              <ListGroup.Item>• Respond to your comments, questions, and requests</ListGroup.Item>
              <ListGroup.Item>• Monitor and analyze trends, usage, and activities</ListGroup.Item>
              <ListGroup.Item>• Detect, investigate, and prevent fraudulent transactions</ListGroup.Item>
              <ListGroup.Item>• Comply with legal obligations and protect our rights</ListGroup.Item>
            </ListGroup>
          </section>

          <section className="mb-5">
            <h2 className="section-title">3. Information Sharing and Disclosure</h2>
            <p>We may share your information in the following situations:</p>
            
            <h5>With Sellers/Buyers</h5>
            <p>To facilitate transactions, we share necessary information between buyers and sellers.</p>
            
            <h5>Service Providers</h5>
            <p>We may employ third-party companies to facilitate our service, provide the service on our behalf, or assist us in analyzing how our service is used.</p>
            
            <h5>
              <FaUserCog className="me-2" />
              Legal Requirements
            </h5>
            <p>We may disclose your information where required to do so by law or in response to valid requests by public authorities.</p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaShieldAlt className="me-2" />
              4. Data Security
            </h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information. 
              However, no method of transmission over the Internet or electronic storage is 100% secure, and we 
              cannot guarantee absolute security.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">5. Your Data Protection Rights</h2>
            <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
            <ul>
              <li>The right to access, update, or delete your information</li>
              <li>The right to rectification of inaccurate information</li>
              <li>The right to object to our processing of your data</li>
              <li>The right to request restriction of processing</li>
              <li>The right to data portability</li>
            </ul>
            <p>To exercise these rights, please contact us at privacy@unitrade.com.</p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">6. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page and updating the "Last Updated" date at the top of this policy.
            </p>
          </section>

          <section>
            <h2 className="section-title">7. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <address>
              <div className="d-flex align-items-center mb-2">
                <FaEnvelope className="me-2" />
                <strong>Email:</strong> support@unitradegh.com
              </div>
              <div className="d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                <strong>Address:</strong> University Energy and Natural Resources, Sunyani, Ghana
              </div>
            </address>
          </section>
        </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default PrivacyPolicy;
